import { trackSearchIrrelevanceCarouselScroll } from "@faire/web-api--source/events/search/scroll/irrelevanceCarousel";
import { trackSearchIrrelevanceCarouselView } from "@faire/web-api--source/events/search/view/irrelevanceCarousel";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";

export const handleSearchIrrelevantCarouselOnViewActions = (
  onViewActions: IAction[],
  actionPositions: string,
  currentNumTilesPerSlide: number
) => {
  onViewActions.forEach((action) => {
    if (
      !action.log_event ||
      action.log_event.event_name !== "search-irrelevance_carousel-view"
    ) {
      return;
    }

    const requestId = action.log_event.parameters[0];
    const rowIndexString = action.log_event.parameters[1];
    if (!rowIndexString || !requestId) {
      return;
    }
    const rowIndex = parseInt(rowIndexString);
    if (isNaN(rowIndex)) {
      return;
    }

    if (actionPositions.startsWith("0 ")) {
      trackSearchIrrelevanceCarouselView(
        requestId,
        (rowIndex * currentNumTilesPerSlide + 1).toString(),
        currentNumTilesPerSlide.toString()
      );
    } else {
      trackSearchIrrelevanceCarouselScroll(requestId);
    }
  });
};
